module.exports = __webpack_public_path__ + "img/w3_circle_list_light.9f5160d2.png";